import { apiRequest } from '@/utils/api-request';
import { unwrap } from '@/services/agents/config';
import type { Agent, AgentResponse } from '@/types/agent-types';

export async function getPrimaryAgent(orgId: string): Promise<Agent | null> {
  const response = await apiRequest<AgentResponse>({
    url: `/agents/${orgId}/primary`,
    method: 'GET',
    target: 'platform',
  });
  const data = unwrap<AgentResponse>(response);
  return data?.agent ?? null;
}
